module.exports = __webpack_public_path__ + "static/media/department.feaad115.svg";